import md5 from 'crypto-js/md5';

const IGI_DOMAIN = 'http://www.infinitus-igi.com';
const KAZAKHSTAN = "KZ";
const INDIVIDUAL = "IDV";
// const FOREIGNER = "FORE";
const PE = "IDVE";
const DISTRIBUTOR = "DIS";
// const WEB = "WEB";
const DISAP = "DISAP";
const PASSPORT = "PPT";

const addLeadingZeroIfNeeded = value => value < 10 ? '0' + value : value;

export const getIgiUrlByKey = (fileKey, lang = 'en') => {
    const convertedLang = lang?.replace('-','_');
    return `${IGI_DOMAIN}/documents/kz_${convertedLang}/${fileKey}.pdf`;
}

export const getVarFromURL = (url, varName) => {
    const parts = url.split("/");
    const targetIndex = parts.indexOf(varName);
    if(targetIndex !== -1) {
        return parts[targetIndex + 1]
    }
    return null;
}

export const getHashedFilePath = (file, fileType) => {
    const ext = file.name.split('.').pop() && file.name.split('.').pop().toLowerCase();
    const hashedFileName = `${md5(file.name).toString()}-${Date.now()}.${ext}`;
    
    return `${fileType}/${KAZAKHSTAN}/${hashedFileName}`;
}

export const getHashedBase64Path = (base64, fileType) => {
    const type = base64.split(';')[0].split('/')[1];
    const hashedFileName = `${md5(base64).toString()}-${Date.now()}.${type}`;
    
    return `${fileType}/${KAZAKHSTAN}/${hashedFileName}`;
}

export const convertCheckExistsApiData = form => {
    let data = {
        "market": KAZAKHSTAN,
        "memberRole": DISTRIBUTOR,
        "memberCode": form.distributor_number,
        "mobileAreaCode": form.telephone_country_code,
        "mobileNumber": form.telephone,
        "email": form.secondary_email,
        "firstNameChn": form.chinese_firstname,
        "lastNameChn": form.chinese_lastname,
        "firstNameEng": form.firstname,
        "lastNameEng": form.lastname
    }

    return ({data});
}

export const convertDistributorApiData = form => {
    let data = {
        "market": KAZAKHSTAN,
        "memberCode": form.distributor_number,
        "firstNameChn": form.chinese_firstname,
        "lastNameChn": form.chinese_lastname,
        "firstNameEng": form.firstname,
        "lastNameEng": form.lastname,
        "memberRole": DISTRIBUTOR,
        "memberType": PE,
        "language": 'ZH-CN',
        "perCountry": KAZAKHSTAN,
        "perState": form.region_id,
        "perCity": form.city_id,
        "perAddress": form.street1,
        "perAddress2": form.street2,
        "perAddress3": "",
        "perZipCode": form.postcode,
        "curCountry": KAZAKHSTAN,
        "mobileAreaCode": form.telephone_country_code,
        "mobileNumber": form.telephone,
        "emailAddress": form.secondary_email,
        "attachments": []
   }
    
    if(form.signature_src) {
        data.attachments.push(
            {"fileType": "PE_SIGNATURE", "fileKey": '/' + form.signature_src}
        )
    }
    if(form.pe_certificate_src) {
        data.attachments.push(
            {"fileType": "PE_CERTIFICATE", "fileKey": '/' + form.pe_certificate_src}
        )
    }
    return ({data});
}